import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { apiResponse } from 'src/app/models/apiResponse.model';
import { ApiFilter, FieldsSelection, DefaultFilter } from 'src/app/models/apiParams.model';
import { valuationOffer } from 'src/app/models/valuationOffer.model';
import { UpdateBidTermRequest } from 'src/app/models/updateBidTermRequest.model';
import { BaseApiService } from '../base/base-api.service';

/**
 * Trade Service - Handles bid terms and valuation offers
 */
@Injectable({ providedIn: 'root' })
export class TradeService extends BaseApiService {
    private readonly basePath = '/trade/v1/';

    constructor(http: HttpClient) {
        super(http);
    }

    /*-------------------------
    == BID TERM CALLS ==
    -------------------------*/

    getBidTerm(limit: number, page: number, orderBy?: string, filter?: string | ApiFilter, fields?: FieldsSelection, defaultFilter?: DefaultFilter): Observable<apiResponse> {
        return this.getAll<apiResponse>(`${this.basePath}bid-term`, { limit, page, orderBy, filter, fields, defaultFilter });
    }

    getBidTermId(id: number): Observable<apiResponse> {
        return this.getById<apiResponse>(`${this.basePath}bid-term/`, id);
    }

    updateBidTerm(id: number, data: UpdateBidTermRequest, customRequestId?: string): Observable<apiResponse> {
        const url = `${this.api_base}${this.basePath}bid-term/${id}`;
        let params = new HttpParams();
        if (customRequestId) {
            params = params.append('customRequestId', customRequestId);
        }
        return this.http.put<apiResponse>(url, data, {
            headers: this.defaultHeaders.set('Content-Type', 'application/json'),
            params
        });
    }

    /*-------------------------
    == VALUATION OFFER CALLS ==
    -------------------------*/

    mailValuationOffer(data: valuationOffer): Observable<apiResponse> {
        return this.post<apiResponse>(`${this.basePath}valuation-offer`, data);
    }

    getExpertBids(limit: number, page: number, orderBy?: string, filter?: string | ApiFilter, fields?: FieldsSelection, defaultFilter?: DefaultFilter): Observable<apiResponse> {
        return this.getAll<apiResponse>(`${this.basePath}bid-term`, { limit, page, orderBy, filter, fields, defaultFilter });
    }
}
